function toUrlSearchParams (params) {
    return Object.keys(params).reduce((urlSearchParams, name) => {
        urlSearchParams.set(name, params[name])
        return urlSearchParams
    }, new URLSearchParams())
}

export default toUrlSearchParams
